import type { TOC } from '@ember/component/template-only';
import { PrismBadge, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface HotelSettingsCentralMappingTablesCellsThAutomationBadgeSignature {
  Args: {
    column: {
      name: string;
    };
  };
}

const HotelSettingsCentralMappingTablesCellsThAutomationBadge = <template>
  <div class="flex flex-row items-center gap-100">
    {{@column.name}}

    <div>
      <PrismBadge
        @badgeType="intelligence"
        @iconName="automation"
        @iconPosition="left"
        @isSmallBadge={{true}}
        @label=""
      />
      <PrismTooltip
        @text={{t
          "settings.central_mapping.table.header_automation_icon.tooltip"
        }}
      />
    </div>
  </div>
</template> satisfies TOC<HotelSettingsCentralMappingTablesCellsThAutomationBadgeSignature>;

export default HotelSettingsCentralMappingTablesCellsThAutomationBadge;
